<template>
  <div class="flex flex-col">
    <template v-if="!started">
      <div class="flex flex-col flex-1">
        <template v-if="status === null">
          <topbar :title="$t('quiz.page-title')" color="purple" />
          <div class="p-2 flex-1">
            <p>{{$t('loading')}}</p>
          </div>
        </template>
        <template v-else-if="status.isCurrent && award">
          <award :award="award" :quiz="status.id" />
        </template>
        <template v-else-if="status.isCurrent && status.answered === false">
          <topbar :title="$t('quiz.page-title')" color="purple" />
          <div class="flex flex-col flex-1 p-3 xl:pt-8">
            <div class="flex-1 max-w-xl xl:max-w-6xl w-full mx-auto">
              <div class="title text-quiz-1 xl:font-bold xl:text-5xl">Mettiti alla prova!</div>
              <div class="xl:text-4xl">
                <p>
                  Partecipa al quiz <i>lìdatè</i> e prova ad aggiudicarti il premio!
                  Rispondi correttamente e nel minor tempo possibile a 5 domande su vari aspetti relativi alle lingue. Il primo classificato si aggiudica un fantastico premio a scelta.
                </p>
                <p>
                  Ricorda che puoi partecipare al quiz fino al {{deadline}}.
                </p>
              </div>
            </div>
            <div class="flex flex-col xl:flex-1 max-w-md w-full mx-auto justify-center">
              <button class="btn btn-quiz-1" @click="startQuiz()">{{$t('begin')}}</button>
            </div>
          </div>
        </template>
        <template v-else>
          <topbar :title="$t('quiz.page-title')" color="purple" />
          <div class="flex flex-col flex-1 p-3 xl:pt-8">
            <div class="flex-1 max-w-xl xl:max-w-6xl w-full mx-auto">
              <div class="title text-quiz-1 xl:font-bold xl:text-5xl">In preparazione</div>
              <div class="xl:text-4xl">
                <p>
                  Il prossimo quiz è in preparazione.<br>
                  Ti avviseremo appena sarà attivato.
                </p>
                <p>
                  Nel frattempo dai un'occhiata alle ultime notizie<!-- e alle risposte ai quiz precedenti-->.
                </p>
              </div>
            </div>
            <div class="flex flex-col xl:flex-1 max-w-md w-full mx-auto justify-center">
              <a target="_blank" href="https://news.lidate.ch" class="block btn btn-quiz-1">
                Maggiori informazioni
              </a>
            </div>
          </div>
        </template>
      </div>
    </template>


    <quiz :quiz="current" v-else-if="current && status.answered === false" @finished="started = false; bindQuizStatus()" />
    <template v-else>
      <div class="flex flex-col flex-1 items-center justify-center p-4">
        <span>{{$t('quiz.preparing-game-session')}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Quiz from '@/components/quizzes/Quiz'
import Award from '@/components/quizzes/Award'

export default {
  data() {
    return {
      started: false
    }
  },
  components: {
    Quiz,
    Award
  },
  computed: {
    ...mapState('quiz', ['status', 'answers', 'award']),
    ...mapGetters('quiz', ['current']),
    deadline() {
      if(this.status && this.status.deadline) {
        const date = new Date(this.status.deadline._seconds * 1000 - 3600000 * 3)
        return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`
      }
      return '';
    }
  },
  methods: {
    ...mapActions('quiz', ['requestQuiz', 'bindQuizAnswers', 'bindQuizAward', 'bindQuizStatus']),

    async startQuiz() {
      if(this.status.id) {
        if (this.status.answered === false) {  
          this.started = true
          await this.bindQuizAnswers(this.status)
          await this.requestQuiz()
        } else {
          console.warn('Quiz already answered')
        }
      }
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 1rem;
}
</style>